function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1394",
  "data-name": "Rectangle 1394",
  width: 120,
  height: 120,
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_744",
  "data-name": "Group 744",
  transform: "translate(-419 -808)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1047-2",
  "data-name": "Path 1047-2",
  d: "M556.98,110.641a1.043,1.043,0,0,1-.253-.141,1.02,1.02,0,0,1-.193-1.429,29.362,29.362,0,0,1,7.764-7.081,1.02,1.02,0,0,1,1.407.321h0a1.02,1.02,0,0,1-.321,1.407h0a27.405,27.405,0,0,0-7.229,6.591A1.021,1.021,0,0,1,556.98,110.641ZM608,124.191a1.021,1.021,0,0,1-.646-.817,27.538,27.538,0,0,0-3-9.31,1.021,1.021,0,0,1,.42-1.38h0a1.02,1.02,0,0,1,1.38.42h0a29.6,29.6,0,0,1,3.23,10,1.02,1.02,0,0,1-.876,1.147h0a1,1,0,0,1-.5-.059Zm-34.12-24.182a1.02,1.02,0,0,1,.157-1.951,29.347,29.347,0,0,1,10.5-.276,1.02,1.02,0,0,1,.853,1.164h0a1.02,1.02,0,0,1-1.161.857h0a27.326,27.326,0,0,0-9.778.257A1.017,1.017,0,0,1,573.884,100.009Zm24.718,6.561a1.066,1.066,0,0,1-.31-.188,27.459,27.459,0,0,0-8.369-5.071,1.02,1.02,0,0,1,.731-1.9,29.485,29.485,0,0,1,8.991,5.442,1.02,1.02,0,0,1,.1,1.44l-.009.009a1.019,1.019,0,0,1-1.128.273Z",
  transform: "translate(-82.177 738.105)",
  fill: "#8cb42d",
  stroke: "#8cb42d",
  strokeWidth: 0.4
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1178",
  "data-name": "Path 1178",
  d: "M570.795,121.227h-.289a.988.988,0,0,0-.977.974c-.01.106-.019.24-.027.407-.014.31-.023.719-.023,1.15l-1.431,40.887c0,.476.008.9.022,1.217.008.163.018.3.03.4a.985.985,0,0,0,.974.973h.289a.988.988,0,0,0,.977-.974c.01-.1.019-.236.026-.4.016-.318.024-.726.024-1.156l1.431-40.886c0-.477-.008-.9-.022-1.218-.008-.164-.017-.3-.029-.4A.987.987,0,0,0,570.795,121.227Z",
  transform: "translate(-80.526 741.455)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1182",
  "data-name": "Path 1182",
  d: "M363.12-16050.425l11.279,61.893-17.225,1.12-1.527-.222-.958-2.427-.789-16.572-2.352-42.295,1.456-1.5H363.12Z",
  transform: "translate(99 16904.088)",
  fill: "#fee3c7"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1183",
  "data-name": "Path 1183",
  d: "M558.324,121.227h-.287a.987.987,0,0,0-.977.974c-.01.106-.021.24-.029.407-.014.317-.023.737-.023,1.181v40.888c0,.444.009.865.023,1.185.008.163.018.3.03.4a.986.986,0,0,0,.975.973h.287a.988.988,0,0,0,.977-.974c.01-.106.021-.24.029-.406.014-.317.023-.738.023-1.182V123.789c0-.444-.009-.864-.023-1.185-.008-.164-.018-.3-.03-.4A.987.987,0,0,0,558.324,121.227Z",
  transform: "translate(-82.081 741.455)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1184",
  "data-name": "Path 1184",
  d: "M547.285,122.607c-.007-.169-.016-.3-.029-.407a.986.986,0,0,0-.975-.973h-.287a.987.987,0,0,0-.975.974c-.011.106-.021.24-.029.407-.015.317-.023.737-.023,1.181l1.431,40.891c0,.459.009.867.023,1.181.008.164.017.3.03.4a.986.986,0,0,0,.975.973h.287a.988.988,0,0,0,.977-.974c.011-.106.019-.24.027-.406.015-.317.023-.738.023-1.182v-.032l-1.431-40.869C547.309,123.328,547.3,122.92,547.285,122.607Z",
  transform: "translate(-83.776 741.455)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1185",
  "data-name": "Path 1185",
  d: "M583.758,112.7H538.791c-3.311,0-3.91,1.735-4,2.082l-.015.065a2.557,2.557,0,0,0-.065.573l3.465,59.273a2.819,2.819,0,0,0,2.86,2.706h40.426a2.809,2.809,0,0,0,2.86-2.674l3.462-59.25a2.567,2.567,0,0,0-.064-.63l-.025-.113C587.432,113.866,586.531,112.817,583.758,112.7Zm2.124,2.779-3.46,59.466-.187.217a1.01,1.01,0,0,1-.769.333H541.04a1.006,1.006,0,0,1-.769-.334l-.187-.216v-.284l-3.48-59.526.243-.243a1.031,1.031,0,0,1,.727-.289h47.358a1.031,1.031,0,0,1,.727.289l.244.243Z",
  transform: "translate(-85.22 740.254)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1187",
  "data-name": "Path 1187",
  d: "M518.169,118.013l2.1,2.717a2.624,2.624,0,0,0,2.1,1.015h.064l.306-.007a5.807,5.807,0,0,0,2.186-1.23l.282-.219,37.722-29.141a5.266,5.266,0,0,0,1.865-2.131,2.629,2.629,0,0,0-.436-2.347l-2.1-2.717a2.717,2.717,0,0,0-3.814-.427L544.319,94.438l-2.018-2.61a3.25,3.25,0,0,0-1.366-1.127,1.3,1.3,0,0,0-.437-.08,1.091,1.091,0,0,0-.68.241l-9.3,7.183c-.682.527-.566,1.516.308,2.648l2.016,2.61-14.127,10.912A2.718,2.718,0,0,0,518.169,118.013ZM532.1,99.227l8.459-6.535,2.091,2.707-8.459,6.533Zm-12.5,16.756.265-.248,39.962-30.872.72-.01,2.507,3.244-.135.608-.258.24-39.954,30.867-.722.025-2.506-3.244Z",
  transform: "translate(-87.626 736.063)",
  fill: "#00a0af"
}));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2025",
  "data-name": "Rectangle 2025",
  width: 120,
  height: 120,
  fill: "none"
});

var SvgIllustrationTrash = function SvgIllustrationTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustration_-_trash",
    "data-name": "illustration - trash",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllustrationTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Illustration_trash.4ca308a9.svg";
export { ForwardRef as ReactComponent };